import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AdminLayout from "../../../src/component/admin/AdminLayout";

import {
  getRetreatById,
  updateRetreat,
} from "../../services/retreatService";

import {
  getRetreatTypes,
} from "../../services/retreatTypeService";

export default function EditRetreat() {  const navigate = useNavigate();
const { id } = useParams();
const [formData, setFormData] = useState({
  
  retreatType: "",
  retreatTitle: "",

  startDate: "",
  endDate: "",

  location: "",
  startingPrice: "",

  cardImage: "",

  bookingUrl: "",

  status: "draft",

  // Pricing
  packages: [
    {
      name: "",
      standardPrice: "",
      discountedPrice: "",
    },
  ],

  // Accommodation Gallery
  accommodationImages: [""],

  // What's Included
  includedItems: [""],
});
const [retreatTypes, setRetreatTypes] = useState([]);
useEffect(() => {
  loadRetreatTypes();

  if (id) {
    loadRetreat();
  }
}, [id]);const loadRetreat = async () => {
  try {
    const res = await getRetreatById(id);

    setFormData({
      retreatType: res.data.retreatTypeId,

      retreatTitle: res.data.retreatTitle,

      startDate: res.data.startDate,

      endDate: res.data.endDate,

      location: res.data.location,

      startingPrice: res.data.startingPrice,

      cardImage: res.data.cardImage,

      bookingUrl: res.data.bookingUrl,

      status: res.data.status,

      packages:
        res.data.packages?.length
          ? res.data.packages
          : [
              {
                name: "",
                standardPrice: "",
                discountedPrice: "",
              },
            ],

      accommodationImages:
        res.data.accommodationImages?.length
          ? res.data.accommodationImages
          : [""],

      includedItems:
        res.data.includedItems?.length
          ? res.data.includedItems
          : [""],
    });
  } catch (err) {
    console.error(err);
  }
};
const loadRetreatTypes = async () => {
  try {
    const res = await getRetreatTypes();
    setRetreatTypes(res.data);
  } catch (err) {
    console.error(err);
  }
};

const handleChange = (e) => {
  setFormData({
    ...formData,
    [e.target.name]: e.target.value,
  });
};

const handlePackageChange = (
  index,
  field,
  value
) => {
  const updatedPackages = [
    ...formData.packages,
  ];

  updatedPackages[index][field] = value;

  setFormData({
    ...formData,
    packages: updatedPackages,
  });
};

const addPackage = () => {
  setFormData({
    ...formData,
    packages: [
      ...formData.packages,
      {
        name: "",
        standardPrice: "",
        discountedPrice: "",
      },
    ],
  });
};
const handleArrayChange = (
  index,
  value,
  field
) => {
  const updated = [...formData[field]];
  updated[index] = value;

  setFormData({
    ...formData,
    [field]: updated,
  });
};

const addArrayItem = (field) => {
  setFormData({
    ...formData,
    [field]: [
      ...formData[field],
      "",
    ],
  });
};
const handleSubmit = async (e) => {
  e.preventDefault();

const payload = {
  retreatTypeId: Number(formData.retreatType),

  retreatTitle: formData.retreatTitle,
  startDate: formData.startDate,
  endDate: formData.endDate,
  location: formData.location,
  startingPrice: formData.startingPrice,
  cardImage: formData.cardImage,
  bookingUrl: formData.bookingUrl,
  status: formData.status,

  packages: formData.packages.filter(
    (pkg) => pkg.name.trim() !== ""
  ),

  accommodationImages: formData.accommodationImages.filter(
    (img) => img.trim() !== ""
  ),

  includedItems: formData.includedItems.filter(
    (item) => item.trim() !== ""
  ),
};
  try {
await updateRetreat(id, payload);
alert("Retreat Updated Successfully");
    navigate("/admin/retreats");
  } catch (err) {
    console.error(err.response?.data || err);
    alert("Failed to create retreat");
  }
};

  return (
    <AdminLayout>
<h1 className="text-4xl font-bold mb-8">
  Edit Retreat Event
</h1>      

      <form
        onSubmit={handleSubmit}
        className="bg-white p-8 rounded-2xl shadow max-w-4xl space-y-5"
      >
        {/* Retreat Type */}
        <div>
          <label className="block mb-2 font-medium">
            Retreat Type
          </label>

<select
  name="retreatType"
  value={formData.retreatType}
  onChange={handleChange}
  className="w-full border p-3 rounded"
>
  <option value="">
    Select Retreat Type
  </option>

  {retreatTypes.map((item) => (
<option
  key={item.id}
  value={item.id}
>
  {item.typeName}
</option>  ))}
</select> </div>

        {/* Retreat Title */}
        <div>
          <label className="block mb-2 font-medium">
            Retreat Title
          </label>

          <input
            name="retreatTitle"
            placeholder="Innergise February Retreat"
            value={formData.retreatTitle}
            onChange={handleChange}
            className="w-full border p-3 rounded"
          />
        </div>
<div>
  <label className="block mb-2 font-medium">
    Card Image
  </label>

  <input
    name="cardImage"
    placeholder="Image URL"
    value={formData.cardImage}
    onChange={handleChange}
    className="w-full border p-3 rounded"
  />
</div>
        {/* Start Date */}
        <div>
          <label className="block mb-2 font-medium">
            Start Date
          </label>

          <input
            type="date"
            name="startDate"
            value={formData.startDate}
            onChange={handleChange}
            className="w-full border p-3 rounded"
          />
        </div>

        {/* End Date */}
        <div>
          <label className="block mb-2 font-medium">
            End Date
          </label>

          <input
            type="date"
            name="endDate"
            value={formData.endDate}
            onChange={handleChange}
            className="w-full border p-3 rounded"
          />
        </div>

        {/* Location */}
        <div>
          <label className="block mb-2 font-medium">
            Location
          </label>

          <input
            name="location"
            placeholder="Rishikesh"
            value={formData.location}
            onChange={handleChange}
            className="w-full border p-3 rounded"
          />
        </div>
<div>
  <label className="block mb-2 font-medium">
    Starting Price
  </label>

  <input
    name="startingPrice"
    placeholder="19999"
    value={formData.startingPrice}
    onChange={handleChange}
    className="w-full border p-3 rounded"
  />
</div>


<div className="border rounded-xl p-5">
  <h3 className="text-xl font-bold mb-4">
    Pricing Packages
  </h3>

  {formData.packages.map(
    (pkg, index) => (
      <div
        key={index}
        className="border rounded-lg p-4 mb-4"
      >
        <input
          placeholder="Package Name"
          value={pkg.name}
          onChange={(e) =>
            handlePackageChange(
              index,
              "name",
              e.target.value
            )
          }
          className="w-full border p-3 rounded mb-3"
        />

        <input
          placeholder="Standard Price"
          value={pkg.standardPrice}
          onChange={(e) =>
            handlePackageChange(
              index,
              "standardPrice",
              e.target.value
            )
          }
          className="w-full border p-3 rounded mb-3"
        />

        <input
          placeholder="Discounted Price"
          value={pkg.discountedPrice}
          onChange={(e) =>
            handlePackageChange(
              index,
              "discountedPrice",
              e.target.value
            )
          }
          className="w-full border p-3 rounded"
        />
      </div>
    )
  )}

  <button
    type="button"
    onClick={addPackage}
    className="bg-gray-200 px-4 py-2 rounded"
  >
    + Add Package
  </button>
</div>
<div className="border rounded-xl p-5">
  <h3 className="text-xl font-bold mb-4">
    Accommodation Images
  </h3>

  {formData.accommodationImages.map(
    (img, index) => (
      <input
        key={index}
        value={img}
        placeholder={`Image ${index + 1}`}
        onChange={(e) =>
          handleArrayChange(
            index,
            e.target.value,
            "accommodationImages"
          )
        }
        className="w-full border p-3 rounded mb-3"
      />
    )
  )}

  <button
    type="button"
    onClick={() =>
      addArrayItem("accommodationImages")
    }
    className="bg-gray-200 px-4 py-2 rounded"
  >
    + Add Image
  </button>
</div>
<div className="border rounded-xl p-5">
  <h3 className="text-xl font-bold mb-4">
    What's Included
  </h3>

  {formData.includedItems.map(
    (item, index) => (
      <input
        key={index}
        value={item}
        placeholder={`Item ${index + 1}`}
        onChange={(e) =>
          handleArrayChange(
            index,
            e.target.value,
            "includedItems"
          )
        }
        className="w-full border p-3 rounded mb-3"
      />
    )
  )}

  <button
    type="button"
    onClick={() =>
      addArrayItem("includedItems")
    }
    className="bg-gray-200 px-4 py-2 rounded"
  >
    + Add Item
  </button>
</div>


        {/* Status */}
        <div>
          <label className="block mb-2 font-medium">
            Status
          </label>

          <select
            name="status"
            value={formData.status}
            onChange={handleChange}
            className="w-full border p-3 rounded"
          >
            <option value="draft">
              Draft
            </option>

            <option value="published">
              Published
            </option>
          </select>
        </div>

        <button
          type="submit"
          className="bg-secondary text-white px-6 py-3 rounded-xl hover:opacity-90"
        >
Update Retreat Event        </button>
      </form>
    </AdminLayout>
  );
}